import { Redirect, Route } from "react-router-dom";
import { selectUser } from "../../features/currentUser/currentUserSelectors";
import { useAppSelector } from "../../hooks/redux";
import { useTokenValidation } from "../../hooks/useTokenValidation";

export const ProtectedPage = ({ component, ...rest }: any) => {
    const {accessToken, refreshToken} = useAppSelector(selectUser);
    const validationState = useTokenValidation(rest.protected);

    // Show nothing while validating protected routes
    if (rest.protected && validationState === 'validating') {
      return null;
    }

    // If validation failed on protected route, redirect to login
    if (rest.protected && validationState === 'invalid') {
      return <Route
        {...rest}
        render={({ location }) => (
            <Redirect
              to={{
                pathname: "/",
                state: { from: location }
              }}
            />
          )
        }
      />;
    }

    switch(true) {
      case ((accessToken && refreshToken && !rest.unauth) || !rest.protected):
        return <Route component={component} {...rest} />

      case (accessToken && refreshToken && rest.unauth):
        return <Route
                  {...rest}
                  render={({ location }) => (
                      <Redirect
                        to={{
                          pathname: "/communities",
                          state: { from: location }
                        }}
                      />
                    )
                  }
                />

      default:
        return <Route
        {...rest}
        render={({ location }) => (
            <Redirect
              to={{
                pathname: "/",
                state: { from: location }
              }}
            />
          )
        }
      />;
  }
};
